// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"43961a73","453":"a2c25ed4","656":"0200da7e","801":"0a481889"}[chunkId] + ".chunk.js";
};